import { render, staticRenderFns } from "./CopyStakeGuidanceView.vue?vue&type=template&id=50ad3d3c&lang=pug"
import script from "./CopyStakeGuidanceView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGuidanceView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeGuidanceView.vue?vue&type=style&index=0&id=50ad3d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCard,VCol,VContainer,VIcon,VList,VListItem,VListItemContent,VRow,VSkeletonLoader})
